import React from "react";
import { Caption2 } from "@activecollab/components";
import PropTypes from "prop-types";
import { BodyItem } from "./BodyItem.jsx";
import UserNameContainer from "../../../../Users/UserNameContainer.jsx";

export const UserNameElement = ({ userId, className }) => {
  return (
    <BodyItem className={className}>
      <Caption2
        color="secondary"
        weight="bold"
        className="group-message-user-name"
      >
        <UserNameContainer
          userId={userId}
          shortName
        />
      </Caption2>
    </BodyItem>
  );
};

UserNameElement.propTypes = {
  userId: PropTypes.number.isRequired,
  className: PropTypes.string,
};
